// @flow
import * as React from 'react';

import { selectIsAuthenticatedUser } from '@gandi/authentication';
import {
  type DecoratedProduct,
  selectCartCurrency,
  selectCartIsCommitted,
  selectCartUUID,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

// eslint-disable-next-line import/no-cycle
import { getProductComponent } from '../tools';

type Props = {
  option: DecoratedProduct,
};

function DomaincCreateOption({ option }: Props): React.MixedElement {
  const translator = useTranslator();
  const Renderer = getProductComponent(option.component);
  const cartCommitted = useAppSelector(selectCartIsCommitted);
  const authenticated = useAppSelector(selectIsAuthenticatedUser);
  const currency = useAppSelector(selectCartCurrency);
  const cartId = useAppSelector(selectCartUUID);

  return (
    <Renderer
      translator={translator}
      cartCommitted={cartCommitted}
      authenticated={authenticated}
      currency={currency}
      cartId={cartId}
      product={option}
    />
  );
}

export default DomaincCreateOption;
